import { FEATURE_NAME_GENERAL_INSIGHTS } from '@bingads-webui-campaign/competition-auction-insight-preferences';

export const PILL_CONTROL = {
  summary: 'summary',
  overtime: 'overtime',
};

export const GENERAL_INSIGHTS_DATA_TYPES = {
  Grid: FEATURE_NAME_GENERAL_INSIGHTS, // grid and shopping grid share the same data source.
  Chart: 'GeneralInsightsChart',
  Tile: 'GeneralInsightsTile',
};
